import { BrowserRouter, useRoutes } from "react-router";
import { appRoutes } from "@/route-table";

function AppRoutes() {
  return useRoutes(appRoutes);
}

/**
 * Three routes, none of which links to another.
 *
 * That is the shape of this app and the reason it needs no layout route, no
 * navigation and no lazy boundaries: `/return` and `/cancel` are each entered
 * by a full page load from Stripe carrying a `?session_id=`, and both leave to
 * a different origin. `/` is the only one a person navigates to. Every page
 * renders `CheckoutShell` itself rather than sitting under a layout route —
 * with three leaves and no shared state, a layout route would be indirection
 * without a payoff.
 *
 * `BrowserRouter` rather than hash routing: wrangler.jsonc sets
 * `not_found_handling: "single-page-application"`, so the Worker serves
 * index.html for any path the asset bundle does not have, and real paths
 * resolve on a cold load.
 *
 * The table itself is ./route-table.tsx, where a test can match the Worker's
 * Stripe return URLs against it.
 */
function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
